import { useState, useCallback } from 'react';
import axios from 'axios';
import { setupAxios } from '../../auth';
const api = axios.create({ baseURL: process.env.REACT_APP_ACCOUNTS_API_URL || '' });
setupAxios(api);

export const useAccountSalespersons = () => {
  const [salespersons, setSalespersons] = useState<string[]>([]);
  const [localAdded, setLocalAdded] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadSalespersons = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('accounts/salespersons');
      const data = response.data?.data || response.data || [];
      setSalespersons(Array.isArray(data) ? data : []);
      setLoaded(true);
    } catch (err: any) {
      console.error('Failed to fetch salespersons:', err);
      setError('Failed to load salespersons');
    } finally {
      setLoading(false);
    }
  }, []);

  const addSalesperson = useCallback((name: string) => {
    setLocalAdded(prev => {
      if (prev.includes(name)) return prev;
      return [...prev, name];
    });
  }, []);

  return {
    salespersons: Array.from(new Set([...salespersons, ...localAdded])),
    loading,
    loaded,
    error,
    loadSalespersons,
    addSalesperson,
  };
};
